export class TemplateInput {
    key = '';
    description = '';
    constructor(template) {
        this.key = template?.key ?? '';
        this.description = template?.description ?? '';
    }
}
